export default __webpack_public_path__ + "static/media/no_notifications.cee1d6b9.svg";